export default __webpack_public_path__ + "static/media/api-credential.038e0b9a.svg";